/**
 * Service to render HTML from templates.
 */
export function templateService() {
  /**
   * Gets the template HTML from the DOM.
   */
  const getTemplateHtml = (id) => {
    const template = document.getElementById(id);
    if (!template) {
      throw new Error(`Template with id "${id}" not found.`);
    }

    return template.innerHTML;
  };

  /**
   * Interpolates a string with the given params.
   *
   * @param {string} str    The string to interpolate
   * @param {object} params The params to interpolate with
   */
  const interpolate = (str, params) => {
    return new Function(...Object.keys(params), `return \`${str}\`;`)(...Object.values(params));
  };

  return {
    /**
     * Renders HTML from a template.
     *
     * @param {string} id     The id of the template in the DOM
     * @param {object} params The params to send to the template
     */
    renderHtmlFromTemplate: (id, params) => {
      return interpolate(getTemplateHtml(id), params);
    },
  };
}
